// ============================================================================
// NumberStepField.jsx — Corelia UI v1.2 (Native number spinner only)
// ============================================================================

import React from "react";
import theme from "../../../styles/theme";
import FormLayout from "./FormLayout";

const NumberStepField = ({
  label = "Duration (weeks)",
  required = false,
  labelPosition = "top",
  labelWidth = null,
  align = "center",

  value,
  onChange,
  placeholder = "Ex: 12",
  disabled = false,
  error = null,

  min = 1,
  max = 520,
  step = 1,

  width = "100%",
  style = {},
  inputStyle = {},
}) => {
  const labelNode = (
    <>
      {label}
      {required && <span style={{ color: theme.colors.text.required, marginLeft: 4 }}>*</span>}
    </>
  );

  return (
    <FormLayout label={labelNode} labelPosition={labelPosition} labelWidth={labelWidth} align={align} width={width} style={style}>
      <input
        type="number"
        value={value ?? ""}
        onChange={(e) => onChange?.(e.target.value === "" ? "" : Number(e.target.value))}
        placeholder={placeholder}
        disabled={disabled}
        min={min}
        max={max}
        step={step}
        style={{
          width: "100%",
          minHeight: theme.form.field.minHeight,
          padding: `${theme.form.field.paddingV}px ${theme.form.field.paddingH}px`,
          fontFamily: theme.form.field.fontFamily,
          fontSize: theme.form.field.fontSize,
          fontWeight: theme.form.field.fontWeight,
          color: theme.form.field.color,
          borderRadius: theme.form.field.borderRadius,
          border: error ? `1px solid ${theme.colors.text.danger}` : theme.form.field.border,
          backgroundColor: disabled ? theme.form.disabled.background : theme.form.field.background,
          outline: "none",
          transition: theme.form.field.transition,
          boxSizing: "border-box",
          ...(disabled ? { color: theme.form.disabled.color, cursor: "not-allowed" } : {}),
          ...inputStyle,
        }}
        onFocus={(e) => {
          if (!disabled) {
            e.target.style.borderColor = theme.form.focus.borderColor;
            e.target.style.boxShadow = theme.form.focus.boxShadow;
          }
        }}
        onBlur={(e) => {
          e.target.style.borderColor = error
            ? theme.colors.text.danger
            : theme.form.field.border.replace("1px solid ", "");
          e.target.style.boxShadow = "none";
        }}
      />

      {error && (
        <div style={{ marginTop: 4, color: theme.colors.text.danger, fontSize: theme.fontSizes.sm, fontFamily: theme.form.label.fontFamily }}>
          {error}
        </div>
      )}
    </FormLayout>
  );
};

export default NumberStepField;